// extracted by mini-css-extract-plugin
export default {"Disclaimer":"style_Disclaimer__toBo-","DisclaimerCopy":"style_DisclaimerCopy__7mNop"};